import { useCallback, useState } from "react";

export function useIntroVideoController({ introVideoRef }) {
  const [videoAudioBlocked, setVideoAudioBlocked] = useState(false);
  const [showUnmuteCTA, setShowUnmuteCTA] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const stopIntroPlayback = useCallback(
    (reset = false) => {
      if (introVideoRef.current) {
        try {
          introVideoRef.current.pause();
          if (reset) introVideoRef.current.currentTime = 0;
        } catch {
          // ignore
        }
        introVideoRef.current.onended = null;
      }
      setIsVideoPlaying(false);
      setShowUnmuteCTA(false);
      setVideoAudioBlocked(false);
    },
    [introVideoRef]
  );

  return {
    videoAudioBlocked,
    setVideoAudioBlocked,
    showUnmuteCTA,
    setShowUnmuteCTA,
    isVideoPlaying,
    setIsVideoPlaying,
    stopIntroPlayback,
  };
}
